module.exports = __webpack_public_path__ + "img/54_29.127f7387.png";